import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-progress-bar"
      className="fixed top-0 left-0 right-0 h-[2px] bg-[#007AFF] z-[90] origin-left"
      style={{ scaleX, boxShadow: "0 0 12px rgba(0,122,255,0.7)" }}
    />
  );
};

export default ScrollProgress;
